import { config, NEWSLETTER_API_URL, USER_API_URL } from "../modules/config";
import { fetchWithRetry } from "../utils/network";

export interface CurrentUser {
  avatar: null | {
    image: null | string;
  };
  publicUserId: string;
}

/**
 * Returns the current user's info.
 */
export async function getCurrentUser(): Promise<CurrentUser | null> {
  const url = USER_API_URL;

  return fetch(url, {
    credentials: "include",
  }).then(async (x) => await x.json());
}

/**
 * Adds the provided email address to a newsletter
 * distribution.
 */
export async function subscribeToNewsletter(email: string, types: string[]) {
  const url = NEWSLETTER_API_URL;

  const formData = new FormData();
  formData.append("email", email);
  formData.append("type", types.join(","));

  const response = await fetchWithRetry(url, {
    method: "POST",
    body: formData,
    headers: {
      "X-BibleProject-Language": config.language,
    },
  });

  return response.ok;
}
